<template>
  <require from="controls/as-widget-stack"></require>
  <require from="controls/as-form-section.html"></require>

  <as-form-section heading="" intro="">
    <div slot="body">
      <div class="form-row">
        <div class="col">
          <as-widget-stack kind="admin-user-selector" new-item-widget-visible.bind="isAdministratorEditing" add-new-item.call="addNewAdministrator(item)" remove-item.call="removeAdministrator(item)" items.bind="administrators" empty-item-template.bind="newEmptySystemUserWrapper"></as-widget-stack>
        </div>
      </div>
    </div>
  </as-form-section>
</template>
